import { DailyReportItem, DailyReportPayloadItem } from 'components/waste-management/interfaces'

export const toDailyReportPayload = (values: DailyReportItem): DailyReportPayloadItem => ({
  assignees: [
    {
      name: values.assignee1Name.trim(),
      jobTitle: `${values.assignee1Function.value}`
    },
    {
      name: values.assignee2Name.trim(),
      jobTitle: `${values.assignee2Function.value}`
    },
    ...(values.assignee3Name
      ? [
          {
            name: values.assignee3Name.trim(),
            jobTitle: `${values.assignee3Function.value}`
          }
        ]
      : [])
  ],
  wasteCompanyList: values.wasteCompanyList.map(company => {
    const grossWeightMeassured = company.grossWeightMeti ? +company.actualWeight : 0

    return company.id != null
      ? { id: company.id, grossWeightMeassured }
      : { wasteCompanyName: company.wasteCompanyName, grossWeightMeassured }
  })
})
